

















































































































import { Mixins, Component, Prop, Ref } from 'vue-property-decorator'
import intToBase64 from 'src/assets/intToBase64'
import MixinForm from 'components/presenter/item/topic/editor/MixinForm'
import FormSlide from 'components/presenter/item/topic/editor/FormSlide.vue'
import FormParams from 'components/presenter/item/topic/editor/FormParams.vue'
import IntegerInput from 'components/IntegerInput.vue'
import ModalDialog from 'components/modals/Dialog.vue'

@Component({
  components: {
    FormSlide,
    FormParams,
    IntegerInput,
    ModalDialog
  }
})
export default class ItemTopicSlidesEditorFormNumber extends Mixins(MixinForm) {

  @Prop()
  readonly corrects!: Json

  @Ref()
  readonly paramsActionsDialog!: ModalDialog

  get params () {
    const params: Json = {}
    for (const slide of this.slides || []) {
      if (slide.type === 'Params') {
        const name = intToBase64(slide.id).replace(/[\+\/]/, '&').substr(0, 6).toUpperCase()
        params[slide.id] = {
          slide,
          name: name.substr(0, 3) + '-' + name.substr(3, 3)
        }
      }
    }
    return params
  }

  get myparams () {
    return this.params[this.slide.params]
  }

  async addParams () {
    this.paramsActionsDialog.hide()
    const id = new Date().getTime().toString()
    const slidesSettings: Json = {}
    slidesSettings[`${id}:id`] = id
    slidesSettings[`${id}:sort`] = 999999
    slidesSettings[`${id}:type`] = 'Params'
    await this.item.data?.save({ slidesSettings })
    this.setOption('params', id)
  }

  setParams (id: string | null) {
    this.paramsActionsDialog.hide()
    this.setOption('params', id)
  }
}
